const FEATURES_DIALOG_OPEN = 'FEATURES_DIALOG_OPEN'

export const featuresActions = {
  setFeaturesDialogOpen: (value: boolean) => {
    return {
      type: 'SET_FEATURES_DIALOG_OPEN',
      payload: value,
    }
  },
}

export const featuresReducer = (state = { featuresDialogOpen: false }, action: any) => {
  switch (action.type) {
    case 'SET_FEATURES_DIALOG_OPEN':
      return { ...state, featuresDialogOpen: action.payload }
    default:
      return state
  }
}

export const featuresSelectors = {
  getFeaturesDialogOpen: (state: any) => state.features.featuresDialogOpen,
}
